module.exports = __webpack_public_path__ + "img/puzzel1-5.6135efea.png";